import axios from "../axios-auth";
import orginal_axios from "axios";

export const generalLedgerService = {
  saveGeneralLedger,
  getAllGeneralLedger,
  getGeneralLedgerDetail,
  saveFiles,
  downloadFile,
  getGeneralLedgerExcelExport,
  getAllGeneralLedgerList,
};

function saveGeneralLedger(generalLedger) {
  if (!generalLedger.id) {
    // new gl
    return axios.post("/auth/general-ledger", generalLedger);
  } else {
    // edit
    return axios.put("/auth/general-ledger", generalLedger);
  }
}

function saveFiles(files, id) {
  return axios.post("/auth/general-ledger/files/" + id, files, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
function getAllGeneralLedger(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }
  let params = {
    page: page,
    size: size,
    sort: sortedBy,
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.ledgerNo) {
    params["ledgerNo"] = searchParams.ledgerNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.type) {
    params["type"] = searchParams.type;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.operationSettingId) {
    params["operationSettingId"] = searchParams.operationSettingId;
  }
  if (searchParams.ledgerBy) {
    params["ledgerBy"] = searchParams.ledgerBy;
  }
  if (searchParams.invoiceNo) {
    params["invoiceNo"] = searchParams.invoiceNo;
  }
  if (searchParams.chequeNo) {
    params["chequeNo"] = searchParams.chequeNo;
  }
  if (searchParams.reference) {
    params["reference"] = searchParams.reference;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  return axios.get("/auth/general-ledger", { params });
}

function getGeneralLedgerDetail(id) {
  return axios.get("/auth/general-ledger/" + id);
}

function downloadFile(id) {
  return axios.get("/auth/general-ledger/downloadFile/" + id, {
    responseType: "blob",
  });
}

function getGeneralLedgerExcelExport(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.ledgerNo) {
    params["ledgerNo"] = searchParams.ledgerNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.type) {
    params["type"] = searchParams.type;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.operationSettingId) {
    params["operationSettingId"] = searchParams.operationSettingId;
  }
  if (searchParams.ledgerBy) {
    params["ledgerBy"] = searchParams.ledgerBy;
  }
  if (searchParams.invoiceNo) {
    params["invoiceNo"] = searchParams.invoiceNo;
  }
  if (searchParams.chequeNo) {
    params["chequeNo"] = searchParams.chequeNo;
  }
  if (searchParams.reference) {
    params["reference"] = searchParams.reference;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }

  return orginal_axios({
    method: "GET",
    url:
      axios.defaults.baseURL +
      "/auth/general-ledger/general-ledger-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  }).then(function(response) {
    return {
      blob: new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      headers: response.headers,
    };
  });
}

function getAllGeneralLedgerList(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }

  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }

  if (searchParams.ledgerNo) {
    params["ledgerNo"] = searchParams.ledgerNo;
  }

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  if (searchParams.type) {
    params["type"] = searchParams.type;
  }

  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.ledgerBy) {
    params["ledgerBy"] = searchParams.ledgerBy;
  }
  if (searchParams.invoiceNo) {
    params["invoiceNo"] = searchParams.invoiceNo;
  }
  if (searchParams.chequeNo) {
    params["chequeNo"] = searchParams.chequeNo;
  }
  if (searchParams.reference) {
    params["reference"] = searchParams.reference;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }

  return axios.get("/auth/general-ledger/print-all-general-ledger", { params });
}
